import { useState } from 'react'
import { CoachIcon, FeedbackIcon } from '../icons/Icons'
import { FeedbackModal } from '../feedback/FeedbackModal'
import styles from './ChatHeader.module.css'

export function ChatHeader() {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false)

  return (
    <div className={styles.header}>
      <div className={styles.avatar}>
        <CoachIcon className={styles.avatarIcon} />
      </div>
      <div className={styles.info}>
        <div className={styles.name}>Resume Coach</div>
        <div className={styles.status}>
          <span className={styles.statusDot} />
          Online
        </div>
      </div>
      <button
        className={styles.feedbackBtn}
        onClick={() => setIsFeedbackOpen(true)}
        title="Send feedback"
      >
        <FeedbackIcon className={styles.feedbackIcon} />
      </button>
      <FeedbackModal
        isOpen={isFeedbackOpen}
        onClose={() => setIsFeedbackOpen(false)}
      />
    </div>
  )
}
